module.exports = __webpack_public_path__ + "media/images/front/common/icon_program-b95f30d39abf9e975a6e89d04dc79f6e.svg";